/**
 * @file Homepage Who We Serve.
 */

import { gsap } from 'gsap';
import debounce from 'just-debounce-it';

/**
 * Homepage Who We Serve component.
 */
const vHpWhoWeServe = () => {
	const hpWhoWeServe = document.querySelector('.v-hp-who-we-serve');

	if (!hpWhoWeServe) {
		return;
	}

	const panels = hpWhoWeServe.querySelectorAll('.v-hp-who-we-serve__block');

	let previousPanel = panels[0];
	let activePanel = panels[0];

	/**
	 * Animate tabs.
	 */
	const animateTabs = debounce(() => {
		gsap.to(activePanel, {
			opacity:    1,
			ease:       'sine.out',
			duration:   0.2,
			onComplete: () => {
				activePanel.classList.add('active');
				gsap.set(activePanel, { clearProps: 'all' });
			},
		});
	}, 200);

	document.addEventListener('v-tab-switch', (e) => {
		const { tab } = e.detail;
		if (tab && tab.closest('.v-hp-who-we-serve')) {
			const panel = hpWhoWeServe.querySelector(`#${tab.getAttribute('aria-controls')}`);

			panels.forEach((p) => { p.setAttribute('aria-hidden', 'true'); p.setAttribute('tabindex', '-1') });
			panel.setAttribute('aria-hidden', 'false');
			panel.setAttribute('tabindex', '0');

			activePanel = panel;
			gsap.to(previousPanel, {
				opacity:    0,
				ease:       'sine.out',
				duration:   0.2,
				onComplete: () => {
					previousPanel.classList.remove('active');
					gsap.set(previousPanel, { clearProps: 'all' });
				},
			});
			animateTabs(panel);
			previousPanel = panel;
		}
	});
};

export default vHpWhoWeServe;
